import { render, staticRenderFns } from "./VineyardProduction.vue?vue&type=template&id=299e8b0f&scoped=true&"
import script from "./VineyardProduction.vue?vue&type=script&lang=js&"
export * from "./VineyardProduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299e8b0f",
  null
  
)

export default component.exports